import React from "react";
import { Modal, Input, Form, Select } from "antd";

import { FORMAT_EMAIL } from '../../../../common/types/regularExpresionType';


const { Option } = Select;

class ContactoFormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };


  correoCustomValidation = (rule, value, callback) => {
    var regexp = new RegExp(FORMAT_EMAIL);
    if (value !== null && value.length > 0 && !regexp.test(value))
      callback('Formato de correo invalido.');

    callback();
  }

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const form = {
          id: values.id,
          nombre: values.nombre,
          direccion: values.direccion,
          telefono: values.telefono,
          correo: values.correo,
          idCliente: values.idCliente,
        };
        this.props.onSave(form, this.props.form);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", { initialValue: this.props.formValues.id });

    getFieldDecorator('idCliente', { initialValue: this.props.formValues.idCliente });

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? "Registrar Contacto"
            : "Modificar Contacto"
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="650px"
      >
        <Form>
          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Nombre">
                {getFieldDecorator("nombre", {
                  initialValue: this.props.formValues.nombre,

                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Input autoComplete="off" />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 form-group">
              <Form.Item label="Telefono">
                {getFieldDecorator("telefono", {
                  initialValue: this.props.formValues.telefono,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                      whitespace: true,
                    },
                  ],
                })(
                  <Input
                    type="tel"
                    placeholder="Ingresar Teléfono"
                    autoComplete="off"
                    maxLength={15}
                  />)}
              </Form.Item>
            </div>

            <div className="col-md-6 form-group">
              <Form.Item label="Correo">
                {getFieldDecorator("correo", {
                  initialValue: this.props.formValues.correo,
                  rules: [
                    {
                      required: false,
                      validator: this.correoCustomValidation
                    }
                  ],
                })(<Input placeholder="Ingresar Correo" autoComplete="off" />)}
              </Form.Item>
            </div>
          </div>

        </Form>
      </Modal>
    );
  }
}
export default Form.create()(ContactoFormModal);
